import { AnimateOnScrolledTo } from './AnimateOnScrolledTo'
import { Container } from './Container'
import { DemoButton } from './DemoButton'

export function SubHero() {
  return (
    <Container variant="gradient">
      <div className="flex items-end py-16 md:pt-24 md:pb-40">
        <div className="flex flex-col flex-1 space-y-11">
          <AnimateOnScrolledTo
            from={{ opacity: 0, x: -8 }}
            to={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.2 }}
            className="flex flex-col items-end"
          >
            <h1 className="font-light text-text-inverted text-balance text-[clamp(2rem,5vw,3.25rem)] leading-tight">
              Resilience Explorer® provides a consistent, up-to-date view of how hazards affect
              infrastructure and communities, supporting organisations to plan, invest, and meet
              their obligations with confidence.
            </h1>
          </AnimateOnScrolledTo>

          {/* <AnimateOnScrolledTo
            from={{ opacity: 0, x: -8 }}
            to={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.2 }}
            className="flex flex-col items-end"
          >
            <h1 className="font-semibold text-text-inverted text-balance text-[clamp(2rem,5vw,3.25rem)] leading-tight">
              Live, accessible risk intelligence for actionable adaptation.
            </h1>
          </AnimateOnScrolledTo> */}
        </div>
        <AnimateOnScrolledTo
          from={{ opacity: 0, transform: 'scale(0.98)' }}
          to={{ opacity: 1, transform: 'scale(1)' }}
          transition={{ duration: 0.2, delay: 0.8 }}
          className="flex flex-col items-end pb-2"
        >
          <DemoButton theme="light" />
        </AnimateOnScrolledTo>
      </div>
    </Container>
  )
}
